import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Camera, GripVertical, Plus, Instagram, Facebook, Youtube, Twitter } from 'lucide-react';
export function DashboardEditProfile() {
  const [socialLinks, setSocialLinks] = useState([{
    id: 1,
    platform: 'Instagram',
    url: 'instagram.com/marcuschen',
    enabled: true,
    icon: Instagram
  }, {
    id: 2,
    platform: 'Facebook',
    url: 'facebook.com/marcuschen',
    enabled: true,
    icon: Facebook
  }, {
    id: 3,
    platform: 'YouTube',
    url: 'youtube.com/@marcuschen',
    enabled: true,
    icon: Youtube
  }, {
    id: 4,
    platform: 'X (Twitter)',
    url: 'x.com/marcuschen',
    enabled: false,
    icon: Twitter
  }]);
  const [profileLinks, setProfileLinks] = useState([{
    id: 1,
    title: 'Compass',
    url: 'compass.com/agents/marcus-chen',
    clicks: 142,
    enabled: true
  }, {
    id: 2,
    title: 'Website',
    url: 'marcuschen.com',
    clicks: 89,
    enabled: true
  }, {
    id: 3,
    title: 'Realtor.com',
    url: 'realtor.com/realestateagents/marcus-chen',
    clicks: 56,
    enabled: true
  }]);
  return <div className="flex h-full min-h-screen" data-id="element-316">
      {/* Left Column: Editor */}
      <div className="flex-1 max-w-3xl border-r border-brand-light bg-brand-offwhite" data-id="element-317">
        <div className="p-8" data-id="element-318">
          <Link to="/admin" className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-dark mb-8 transition-colors" data-id="element-319">
            <ArrowLeft size={16} data-id="element-320" />
            Back to profile
          </Link>

          <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-8" data-id="element-321">
            Edit Profile
          </h1>

          {/* Profile Details Section */}
          <section className="bg-white rounded-2xl border border-brand-light shadow-sm p-6 mb-8" data-id="element-322">
            <h2 className="text-lg font-medium text-brand-dark mb-6" data-id="element-323">
              Profile Details
            </h2>

            <div className="flex items-center gap-6 mb-8" data-id="element-324">
              <div className="relative w-24 h-24 rounded-full overflow-hidden border border-brand-light group cursor-pointer" data-id="element-325">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-full h-full object-cover" data-id="element-326" />
                <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-327">
                  <Camera size={20} className="text-white mb-1" data-id="element-328" />
                  <span className="text-[10px] text-white font-medium" data-id="element-329">
                    Change
                  </span>
                </div>
              </div>
              <div className="flex-1" data-id="element-330">
                <button className="px-4 py-2 bg-brand-offwhite border border-brand-light hover:bg-brand-sage rounded-xl text-sm font-medium text-brand-dark transition-colors" data-id="element-331">
                  Upload new image
                </button>
                <p className="text-xs text-brand-muted mt-2" data-id="element-332">
                  JPG, GIF or PNG. Max size of 5MB.
                </p>
              </div>
            </div>

            <div className="space-y-4" data-id="element-333">
              <div className="grid grid-cols-2 gap-4" data-id="element-334">
                <div data-id="element-335">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-336">
                    Display Name
                  </label>
                  <input type="text" defaultValue="Marcus Chen" className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-337" />
                </div>
                <div data-id="element-338">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-339">
                    Title
                  </label>
                  <input type="text" defaultValue="Senior real estate advisor" className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-340" />
                </div>
              </div>

              <div data-id="element-341">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-342">
                  Brokerage
                </label>
                <input type="text" defaultValue="Compass Real Estate · The Chen Group" className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-343" />
              </div>

              <div data-id="element-344">
                <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-345">
                  Short URL
                </label>
                <div className="flex items-center bg-white border border-brand-light rounded-xl overflow-hidden focus-within:border-brand-forest focus-within:ring-1 focus-within:ring-brand-forest/20 transition-colors" data-id="element-346">
                  <span className="px-4 py-3 bg-brand-offwhite border-r border-brand-light text-sm text-brand-muted font-mono" data-id="element-347">
                    eaves.pro/
                  </span>
                  <input type="text" defaultValue="marcuschen" className="flex-1 px-4 py-3 text-sm outline-none font-mono" data-id="element-348" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4" data-id="element-349">
                <div data-id="element-350">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-351">
                    Location
                  </label>
                  <input type="text" defaultValue="San Francisco Bay Area" className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors" data-id="element-352" />
                </div>
                <div data-id="element-353">
                  <label className="block text-xs font-medium text-brand-muted mb-1.5" data-id="element-354">
                    DRE Number
                  </label>
                  <input type="text" defaultValue="02145678" className="w-full bg-white border border-brand-light rounded-xl px-4 py-3 text-sm focus:border-brand-forest focus:ring-1 focus:ring-brand-forest/20 outline-none transition-colors font-mono" data-id="element-355" />
                </div>
              </div>
            </div>
          </section>

          {/* Social Links Section */}
          <section className="bg-white rounded-2xl border border-brand-light shadow-sm p-6 mb-8" data-id="element-356">
            <div className="flex items-center justify-between mb-6" data-id="element-357">
              <h2 className="text-lg font-medium text-brand-dark" data-id="element-358">
                Social Links
              </h2>
              <button className="inline-flex items-center gap-1.5 text-sm text-brand-forest font-medium hover:text-brand-forestHover transition-colors" data-id="element-359">
                <Plus size={16} data-id="element-360" />
                Add social
              </button>
            </div>

            <div className="space-y-3" data-id="element-361">
              {socialLinks.map(link => {
              const Icon = link.icon;
              return <div key={link.id} className="flex items-center gap-4 p-4 bg-brand-offwhite/50 border border-brand-light rounded-xl" data-id="element-362">
                    <div className="w-8 h-8 rounded-full bg-white border border-brand-light flex items-center justify-center shrink-0" data-id="element-363">
                      <Icon size={14} className="text-brand-muted" data-id="element-364" />
                    </div>
                    <div className="flex-1" data-id="element-365">
                      <input type="text" defaultValue={link.url} className="w-full bg-transparent text-sm outline-none text-brand-dark placeholder:text-brand-light" placeholder={`${link.platform} URL`} data-id="element-366" />
                    </div>
                    <button className={`w-10 h-6 rounded-full transition-colors relative ${link.enabled ? 'bg-brand-forest' : 'bg-gray-200'}`} onClick={() => {
                  const newLinks = [...socialLinks];
                  const idx = newLinks.findIndex(l => l.id === link.id);
                  newLinks[idx].enabled = !newLinks[idx].enabled;
                  setSocialLinks(newLinks);
                }} data-id="element-367">
                      <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${link.enabled ? 'left-5' : 'left-1'}`} data-id="element-368"></div>
                    </button>
                  </div>;
            })}
            </div>
          </section>

          {/* Profile Links Section */}
          <section className="bg-white rounded-2xl border border-brand-light shadow-sm p-6 mb-8" data-id="element-369">
            <div className="flex items-center justify-between mb-6" data-id="element-370">
              <h2 className="text-lg font-medium text-brand-dark" data-id="element-371">
                Profile Links
              </h2>
              <button className="inline-flex items-center gap-1.5 px-4 py-2 bg-brand-forest text-white rounded-full text-sm font-medium hover:bg-brand-forestHover transition-colors" data-id="element-372">
                <Plus size={16} data-id="element-373" />
                Add link
              </button>
            </div>

            <div className="space-y-4" data-id="element-374">
              {profileLinks.map(link => <div key={link.id} className="flex items-start gap-3 p-4 bg-white border border-brand-light rounded-xl shadow-sm group" data-id="element-375">
                  <button className="mt-2 text-brand-light group-hover:text-brand-muted cursor-grab" data-id="element-376">
                    <GripVertical size={18} data-id="element-377" />
                  </button>
                  <div className="flex-1 space-y-2" data-id="element-378">
                    <input type="text" defaultValue={link.title} className="w-full font-medium text-brand-dark outline-none placeholder:text-brand-light" placeholder="Title" data-id="element-379" />
                    <input type="text" defaultValue={link.url} className="w-full text-sm text-brand-muted outline-none placeholder:text-brand-light" placeholder="URL" data-id="element-380" />
                    <div className="flex items-center gap-2 pt-2" data-id="element-381">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium bg-brand-sage text-brand-forest" data-id="element-382">
                        {link.clicks} clicks
                      </span>
                    </div>
                  </div>
                  <button className={`w-10 h-6 rounded-full transition-colors relative shrink-0 mt-1 ${link.enabled ? 'bg-brand-forest' : 'bg-gray-200'}`} onClick={() => {
                const newLinks = [...profileLinks];
                const idx = newLinks.findIndex(l => l.id === link.id);
                newLinks[idx].enabled = !newLinks[idx].enabled;
                setProfileLinks(newLinks);
              }} data-id="element-383">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${link.enabled ? 'left-5' : 'left-1'}`} data-id="element-384"></div>
                  </button>
                </div>)}
            </div>
          </section>

          {/* Save Button */}
          <div className="flex justify-end" data-id="element-385">
            <button className="px-6 py-3 bg-brand-forest hover:bg-brand-forestHover text-white font-medium rounded-xl transition-colors shadow-sm" data-id="element-386">
              Save changes
            </button>
          </div>
        </div>
      </div>

      {/* Right Column: Phone Preview */}
      <div className="hidden lg:flex w-[400px] bg-white border-l border-brand-light flex-col items-center py-12 sticky top-0 h-screen overflow-hidden" data-id="element-387">
        <div className="mb-6 px-4 py-2 bg-brand-offwhite rounded-full border border-brand-light text-xs font-mono text-brand-muted flex items-center gap-2" data-id="element-388">
          <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-389"></span>
          eaves.pro/marcuschen
        </div>

        {/* Phone Frame */}
        <div className="w-[320px] h-[650px] border-[10px] border-gray-900 rounded-[2.5rem] overflow-hidden shadow-2xl relative bg-brand-offwhite" data-id="element-390">
          {/* Notch */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-2xl z-50" data-id="element-391"></div>

          {/* Mini Profile Content */}
          <div className="h-full overflow-y-auto hide-scrollbar pb-10" data-id="element-392">
            {/* Banner */}
            <div className="h-32 bg-gradient-to-r from-brand-sage via-brand-sandstoneBg to-brand-light relative" data-id="element-393">
              <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-forest to-transparent" data-id="element-394"></div>
            </div>

            <div className="px-4 -mt-12 relative z-10" data-id="element-395">
              <div className="bg-white rounded-xl shadow-sm border border-brand-light p-4" data-id="element-396">
                <div className="w-20 h-20 rounded-full border-4 border-white shadow-sm bg-white -mt-10 mb-3 mx-auto overflow-hidden" data-id="element-397">
                  <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-full h-full object-cover" data-id="element-398" />
                </div>

                <div className="text-center mb-4" data-id="element-399">
                  <h1 className="text-xl font-serif font-semibold text-brand-dark mb-0.5" data-id="element-400">
                    Marcus Chen
                  </h1>
                  <h2 className="text-xs text-brand-muted font-serif italic mb-2" data-id="element-401">
                    Senior real estate advisor
                  </h2>
                  <p className="text-[10px] text-brand-muted flex items-center justify-center gap-1" data-id="element-402">
                    San Francisco Bay Area
                  </p>
                </div>

                <div className="flex justify-center gap-1.5 mb-4" data-id="element-403">
                  {socialLinks.filter(l => l.enabled).map(link => {
                  const Icon = link.icon;
                  return <div key={link.id} className="w-7 h-7 rounded-full bg-brand-offwhite flex items-center justify-center" data-id="element-404">
                          <Icon size={12} className="text-brand-muted" data-id="element-405" />
                        </div>;
                })}
                </div>

                <div className="space-y-2" data-id="element-406">
                  {profileLinks.filter(l => l.enabled).map(link => <div key={link.id} className="w-full py-2 px-3 bg-brand-offwhite border border-brand-light rounded-lg text-center text-xs font-medium text-brand-dark" data-id="element-407">
                        {link.title}
                      </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}